export default class Child {
    static fromData(data) {
        if (!data) {
            return;
        }

        const child = new Child();
        child.id = data.id;
        child.firstName = data.firstname;
        child.lastName = data.lastname;
        child.contractStatus = data.contract_status;
        child.kindergartenId = data.kindergarten_id;
        child.notesGeneral = data.notes_general;
        if (data.notes_accounting !== undefined) {
            child.notesAccounting = data.notes_accounting;
        }

        Object.seal(child);
        return child;
    }
}
